window.gtmDL = window.gtmDL || [{
  "env": window.sqlhabitEnv
}];

export default (eventName, params) => {
  window.gtmDL.push({
    "event": eventName,
    ...params
  });
}
